import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Verify from './pages/Verify';
import RegisterName from './pages/RegisterName';
import CaptureCam from './pages/CaptureCam';
import ProcessingStatus from './pages/ProcessingStatus';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/verify" element={<Verify />} />
        <Route path="/register-name" element={<RegisterName />} />
        <Route path="/capture-cam" element={<CaptureCam />} />
        <Route path="/processing-status" element={<ProcessingStatus />} />
        <Route path="/politica-de-privacidade" element={<PrivacyPolicy />} />
        <Route path="/termos-de-servico" element={<TermsOfService />} />
      </Routes>
    </Router>
  );
}

export default App;
